import { useCallback } from 'react';

import { displayBrightnessController } from './display-brightness.controller';

import type { SetDisplayBrightness } from './display-brightness.types';

export const useDisplayBrightness = (): SetDisplayBrightness => {
  return useCallback((brightness) => displayBrightnessController.setBrightness(brightness), []);
};
